import { createReducer } from '@reduxjs/toolkit';
import * as Actions from '../actions';

export interface EVisitState {
  eVisitState: string;
  eVisitSessionToken: string;
  isFetching: boolean;
  error: boolean;
}

export const defaultEVisitState: EVisitState = {
  eVisitState: '',
  eVisitSessionToken: '',
  isFetching: false,
  error: false
};

const eVisitReducer = createReducer(defaultEVisitState, {
  [Actions.START_E_VISIT]: state => {
    state.isFetching = true;
    state.error = false;
  },
  [Actions.START_E_VISIT_FAIL]: state => {
    state.isFetching = false;
    state.error = true;
  },
  [Actions.START_E_VISIT_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.eVisitState = action.payload;
  },
  [Actions.SET_E_VISIT_SESSION_TOKEN]: (state, action) => {
    state.eVisitSessionToken = action.payload;
  },
  [Actions.RESET_E_VISIT_SESSION_TOKEN]: state => {
    state.eVisitSessionToken = '';
  }
});

export default eVisitReducer;
